export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* Brand */}
          <div className="lg:col-span-2">
            <a href="/" className="flex items-center gap-2">
              <img src="/aura-logo.png" alt="PulseStack AI" className="h-7 w-auto" />
              <span className="text-lg font-bold text-gray-900">PulseStack <span className="text-primary-600">AI</span></span>
            </a>
            <p className="mt-3 text-sm text-gray-500 max-w-xs leading-relaxed">
              Clinical AI tools for Canadian clinics. We build software that gives physicians time back in their day.
            </p>
            <p className="mt-3 text-xs text-gray-400">PulseStack AI Inc. · Hamilton, Ontario</p>
            <div className="mt-4 flex gap-4">
              <a href="https://instagram.com/pulsestack.ai" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-gray-400 hover:text-primary-600 transition-colors">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a href="https://www.linkedin.com/company/pulse-stack/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-gray-400 hover:text-primary-600 transition-colors">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Product */}
          <div>
            <h3 className="text-xs font-semibold text-gray-900 uppercase tracking-widest mb-4">Product</h3>
            <ul className="space-y-2.5">
              {[
                { label: 'Aura-Chart', href: '/solutions/aura-chart.html' },
                { label: 'Aura-Triage', href: '/solutions/aura-triage.html' },
                { label: 'Pricing', href: '/#pricing' },
                { label: 'Changelog', href: '/changelog.html' },
                { label: 'User Guide', href: '/guide/' },
                { label: 'Blog', href: '/blog/' },
              ].map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-sm text-gray-500 hover:text-primary-600 transition-colors">{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-xs font-semibold text-gray-900 uppercase tracking-widest mb-4">Company</h3>
            <ul className="space-y-2.5">
              {[
                { label: 'About', href: '/company.html' },
                { label: 'Team', href: '/team.html' },
                { label: 'Contact', href: '/contact.html' },
                { label: 'Security', href: '/security.html' },
                { label: 'Partnerships', href: 'mailto:partnerships@pulsestack.ai' },
                { label: 'Stay in Touch', href: '/opt-in.html' },
                {
                  label: 'Share Feedback',
                  href: 'https://docs.google.com/forms/d/e/1FAIpQLSc4HY0KZ_BiWLvo17XFtT8vAMo0HVyEFVp5jYbaLc3yCQJo0g/viewform',
                  external: true,
                },
              ].map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    {...(l.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                    className="text-sm text-gray-500 hover:text-primary-600 transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-100 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-gray-400">
          <p>© {year} PulseStack AI Inc. All rights reserved.</p>
          <div className="flex gap-5">
            <a href="/privacy.html" className="hover:text-gray-600 transition-colors">Privacy Policy</a>
            <a href="/terms.html" className="hover:text-gray-600 transition-colors">Terms</a>
            <a href="/security.html" className="hover:text-gray-600 transition-colors">Security</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
